import i18n from 'i18next';
import type { Organization } from 'sdk';
import { ApiError } from '~/lib/api';
import { toaster } from '~/modules/common/toaster/toaster';
import { publicProjectQueryOptions } from '~/modules/project/query';
import { queryClient } from '~/query/query-client';

type PublicProjectRouteBeforeLoadArgs = { params: { slug: string; tenantId: string; organizationSlug: string } };

/** beforeLoad of the public project route: loads the project and a minimal organization context, since the authenticated organization layout is absent. */
export const publicProjectRouteBeforeLoad = async ({ params }: PublicProjectRouteBeforeLoadArgs) => {
  const { slug, tenantId, organizationSlug } = params;
  try {
    const project = await queryClient.ensureQueryData(publicProjectQueryOptions(slug, true));

    const organization = { id: project.organizationId, slug: organizationSlug, tenantId, entityType: 'organization' as const } as Organization;

    return { project, tenantId, organization };
  } catch (err) {
    if (err instanceof ApiError) {
      toaster.info(i18n.t('c:project_not_public.text'));
    }
    throw err;
  }
};
